import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const invoicingPaths = {
	default: '',
	root: 'invoicing',
	billable: 'billable',
	historical: 'historical',
};

export const invoicesFragments = {
	default: [invoicingPaths.default],
	root: [invoicingPaths.default, invoicingPaths.root],
	billable: [
		invoicingPaths.default,
		invoicingPaths.root,
		invoicingPaths.billable,
	],
	historical: [
		invoicingPaths.default,
		invoicingPaths.root,
		invoicingPaths.historical,
	],
};

export const invoicingDefaultAuthRoles = [Roles.Admin, Roles.Billing];

export const invoicingDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: invoicingDefaultAuthRoles },
};
